module.exports = __webpack_public_path__ + "static/media/global_card4.ef966dde.svg";